"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GraceKennedyValidationUtils = void 0;
var Validator_1 = require("../../common/Validator");
var ValidationUtils_1 = require("../../ValidationUtils");
var ProductApiTypes_1 = require("@hit/policy-admin-types/dist/data-model/ProductApiTypes");
var GraceKennedyValidationUtils = /** @class */ (function () {
    function GraceKennedyValidationUtils() {
    }
    GraceKennedyValidationUtils.isValidDOB = function (dob, productType, productCode) {
        var specObj = Validator_1.Validator.fetchSpecObjectFromSpecs(productType, productCode);
        if (!specObj) {
            return ValidationUtils_1.ValidationUtils.getGenericProductSpecError();
        }
        var _a = specObj.specs, ageMin = _a.ageMin, ageMax = _a.ageMax;
        var tooYoung = ValidationUtils_1.ValidationUtils.isYoungerThanAge(dob, ageMin);
        var tooOld = ValidationUtils_1.ValidationUtils.isOlderThanOrEqualToAge(dob, ageMax);
        if (tooYoung || tooOld) {
            return {
                isValid: false,
                message: "Must be between ".concat(ageMin, " and ").concat(ageMax, " years old")
            };
        }
        return { isValid: true };
    };
    GraceKennedyValidationUtils.isValidDuration = function (duration, productType, productCode) {
        var specObj = Validator_1.Validator.fetchSpecObjectFromSpecs(productType, productCode);
        if (!specObj) {
            return ValidationUtils_1.ValidationUtils.getGenericProductSpecError();
        }
        var durationMin = specObj.specs.durationMin;
        var durationMax = specObj.specs.durationMax;
        var tooLow = duration < durationMin;
        var tooHigh = duration > durationMax;
        if (tooLow) {
            var message = productCode === ProductApiTypes_1.ProductCode.LongTermLoan
                ? "This should be more than ".concat(durationMin - 1, " ").concat(getMonthStringBasedOnDuration(durationMin - 1), " for Level Premium Insurance. Choose the Single Premium Insurance if the loan duration is ").concat(durationMin - 1, " ").concat(getMonthStringBasedOnDuration(durationMin - 1), " or less.")
                : "Single premium insurance can't be purchased for loan duration less than ".concat(durationMin, " ").concat(getMonthStringBasedOnDuration(durationMin), ".");
            return {
                isValid: false,
                message: message
            };
        }
        if (tooHigh) {
            var message = productCode === ProductApiTypes_1.ProductCode.LongTermLoan
                ? "Level premium insurance can't be purchased for loan duration more than ".concat(durationMax, " ").concat(getMonthStringBasedOnDuration(durationMax), ".")
                : "This should be ".concat(durationMax, " ").concat(getMonthStringBasedOnDuration(durationMax), " or less for Single Premium Insurance. Choose the Level Premium Insurance if the loan duration is more than ").concat(durationMax, " ").concat(getMonthStringBasedOnDuration(durationMax), ".");
            return {
                isValid: false,
                message: message
            };
        }
        return { isValid: true };
    };
    GraceKennedyValidationUtils.isValidAmount = function (amount, productType, productCode) {
        var specObj = Validator_1.Validator.fetchSpecObjectFromSpecs(productType, productCode);
        if (!specObj) {
            return ValidationUtils_1.ValidationUtils.getGenericProductSpecError();
        }
        var _a = specObj.specs, faceValueMin = _a.faceValueMin, faceValueMax = _a.faceValueMax;
        var tooLow = amount < faceValueMin;
        var tooHigh = amount > faceValueMax;
        if (tooLow || tooHigh) {
            var isLevelPremium = productCode === ProductApiTypes_1.ProductCode.LongTermLoan;
            var moreOrLess = void 0, valueToInclude = void 0;
            if (tooHigh) {
                moreOrLess = 'more';
                valueToInclude = faceValueMax;
            }
            else {
                moreOrLess = 'less';
                valueToInclude = faceValueMin;
            }
            return {
                isValid: false,
                message: "".concat(isLevelPremium ? 'Level' : 'Single', " premium insurance can't be purchased for ").concat(isLevelPremium ? 'coverage' : 'loan', " amount ").concat(moreOrLess, " than ").concat(ValidationUtils_1.ValidationUtils.formatIntCurrency(valueToInclude, 'XCD'))
            };
        }
        return { isValid: true };
    };
    GraceKennedyValidationUtils.isValidCoverageChoice = function (borrowerCoverageChoice, coBorrowerCoverageChoice, hasCoborrower) {
        if (borrowerCoverageChoice) {
            var isBorrowerCoverageChoiceNone = borrowerCoverageChoice === 'none';
            var isCoBorrowerCoverageChoiceNone = coBorrowerCoverageChoice === 'none';
            if (isBorrowerCoverageChoiceNone && (!hasCoborrower || isCoBorrowerCoverageChoiceNone)) {
                return {
                    isValid: false,
                    message: "Coverage is required for at least one borrower."
                };
            }
        }
        return { isValid: true };
    };
    return GraceKennedyValidationUtils;
}());
exports.GraceKennedyValidationUtils = GraceKennedyValidationUtils;
function getMonthStringBasedOnDuration(duration) {
    return duration === 1 ? 'month' : 'months';
}
